import React from 'react';
import './styles.css';

interface DeclaracionJuradaProps {
  isOpen: boolean;
  onAccept: () => void;
  onReject: () => void;
}

const DeclaracionJurada: React.FC<DeclaracionJuradaProps> = ({
  isOpen,
  onAccept,
  onReject,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay-ddjj">
      <div className="modal-container-ddjj">
        <div className="modal-header-ddjj">
          <h2>DECLARACIÓN JURADA</h2>
        </div>
        <div className="modal-body-ddjj">
          <p>
            Por medio de la presente declaro conocer y dar
            cumplimiento a los procedimientos, anexos,
            especificaciones técnicas de YPF SA, así como leyes,
            decretos y medidas preventivas analizadas en la evaluación
            de riesgo de las tareas, comprometiéndome a difundirlas y
            aplicarlas en todas las fases del trabajo.
          </p>
          <p className="emphasis-text">
            Declaro haber recibido, leído y comprendido en su
            totalidad los detalles del Plan de Emergencia y Rescate.
            Me comprometo a aplicar y cumplir el rol que me ha sido
            asignado.
          </p>
          <p className="qr-text">
            Se realizará toma de conocimiento previo al inicio de las
            tareas mediante código QR.
          </p>
        </div>
        <div className="modal-footer-ddjj">
          <button className="btn-acepto" onClick={onAccept}>
            ACEPTO
          </button>
          <button className="btn-no-acepto" onClick={onReject}>
            NO ACEPTO
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclaracionJurada;
